class NavigationController {
    constructor() {
        this.isAuthenticated = false;
        this.restrictedPaths = ['/signin', '/login'];
        this.init();
    }

    init() {
        // Listen for back/forward navigation attempts
        window.addEventListener('popstate', this.handlePopState.bind(this));
        
        // Override browser back button behavior
        window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this));
    }

    setAuthenticationState(isAuthenticated) {
        this.isAuthenticated = isAuthenticated;
        
        if (isAuthenticated) {
            // When user signs in, clear the history to prevent going back
            this.clearAuthHistory();
        }
    }

    handlePopState(event) {
        // If user is authenticated and tries to go to restricted path
        if (this.isAuthenticated && this.isRestrictedPath(window.location.pathname)) {
            // Prevent going to sign-in page, redirect to main app
            event.preventDefault();
            window.history.pushState(null, '', '/');
            return false;
        }
    }

    handleBeforeUnload(event) {
        // Optional: Warn user before leaving the app
        if (this.isAuthenticated) {
            // Uncomment if you want to show warning when leaving
            // event.preventDefault();
            // event.returnValue = '';
        }
    }

    isRestrictedPath(path) {
        return this.restrictedPaths.some(restrictedPath => 
            path.includes(restrictedPath)
        );
    }

    clearAuthHistory() {
        // Replace current history entry to prevent going back to sign-in
        window.history.replaceState(null, '', '/');
        
        // Push the same state again to create a "barrier"
        window.history.pushState(null, '', '/');
    }

    navigateReplace(url) {
        // Replace current entry instead of adding new one
        window.history.replaceState(null, '', url);
    }

    preventBackNavigation() {
        // Nuclear option: completely prevent back navigation
        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', () => {
            window.history.pushState(null, '', window.location.href);
        });
    }
}

export const navigationController = new NavigationController();
